
import { useEffect, useMemo, useRef, useState } from 'react'
import './style.scss'
// import { EDITING_OPTIONS, EDITING_STATE } from '../../types/types'
import { EDITING_STATE } from '../../types/types'
import { analysisStateData } from '../../data/analysisStateData'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { AnalysisFeedback, AnalysisFeedbackDataLine, AnalysisFeedbackDataRecording, AnalysisFeedbackDataShapeRectangle, AnalysisFeedbackDataText, AnalysisFeedbackTypes } from '../../types/videoAnalysisTypes';
import { GetAngleBetweenPoints, GetLengthBetweenPoints } from '../../utils/Utils';
import { setShowPreview } from '../../redux/reducers/toolSlice'

function DashboardToolEditArea() {
	const dispatch = useAppDispatch()
	const innerWidth: number = useAppSelector(state => state.resize.innerWidth)
	const showPreview: boolean = useAppSelector(state => state.tool.showPreview)
	const [videoSrc, setVideoSrc] = useState<string | undefined>(undefined)
	const [currentState, setCurrentState] = useState<EDITING_STATE>(EDITING_STATE.IDLE)
	const [currentDrawingState, setCurrentDrawingState] = useState<EDITING_STATE>(EDITING_STATE.IDLE)
	const [drawingPos, setDrawingPos] = useState<{x:number,y:number}>({x:0,y:0})
	const [drawingPosEnd, setDrawingPosEnd] = useState<{x:number,y:number}>({x:0,y:0})

	const [drawingClientPos, setDrawingClientPos] = useState<{x:number,y:number}>({x:0,y:0})
	const [drawingLineHeight, setDrawingLineHeight] = useState<number>(0)
	const [drawingLineAngle, setDrawingLineAngle] = useState<number>(0)
	const [videoState, setVideoState] = useState<'paused' | 'playing'>('paused')

	const videoWrapperRef = useRef<HTMLDivElement>(null)
	const videoRef = useRef<HTMLVideoElement>(null)
	const previewVideoRef = useRef<HTMLVideoElement>(null)
	const [videoTime, setVideoTime] = useState<number>(0)
	const [videoWrapperWidth, setVideoWrapperWidth] = useState<number>(0)
	const [videoWrapperHeight, setVideoWrapperHeight] = useState<number>(0)
	// const VIDEO_SPACE_HEIGHT_RATIO: number = 1.75 // height ratio of the video wrapper relative to its width, note video will scale to fit the given area and used to determine overlay element positions

	const [isRecording, setIsRecording] = useState<boolean>(false)
	const mediaStream = useRef<MediaStream | undefined>(undefined)
	const mediaRecorder = useRef<MediaRecorder | undefined>(undefined)
	const mediaChunks = useRef<Blob[]>([])
	const [mediaUrl, setMediaUrl] = useState<string>('')

	const [textNote, setTextNote] = useState<string>('')

	const [feedbacks, setFeedbacks] = useState<AnalysisFeedback[]>([])

	// const [showPreviewVideo, setShowPreviewVideo] = useState<boolean>(false)

	useEffect(() => {
		setVideoSrc(analysisStateData.getVideoSrc())
		updateFeedbacks()
	}, [])

	useEffect(() => {
		if (videoWrapperRef.current) {
			setVideoWrapperWidth(videoWrapperRef.current.clientWidth)
			setVideoWrapperHeight(videoWrapperRef.current.clientHeight)
		}
	}, [videoWrapperRef.current, innerWidth])

	const updateFeedbacks = () => {
		setFeedbacks(analysisStateData.getFeedbacks())
		// setFeedbacks([{
		// 	type: AnalysisFeedbackTypes.TEXT_NOTE,
		// 	time: 3,
		// 	duration: 3,
		// 	data: { str: 'Test String' } as AnalysisFeedbackDataText
		// }])
	}

	// ======================================== BUTTON CLICK EVENTS
	const onClickEditButton = () => {
		if (currentState == EDITING_STATE.IDLE) {
			setCurrentState(EDITING_STATE.DRAWING)
		} else {
			// setCurrentState(EDITING_STATE.IDLE)
			resetState()
		}
	}
	const onClickAngleButton = () => {
		if (currentState == EDITING_STATE.IDLE) {
			setCurrentState(EDITING_STATE.DRAWING_ANGLE)
		} else {
			// setCurrentState(EDITING_STATE.IDLE)
			resetState()
		}
	}
	const onClickLineButton = () => {
		if (currentState == EDITING_STATE.IDLE) {
			setCurrentState(EDITING_STATE.DRAWING_LINE)
		} else {
			// setCurrentState(EDITING_STATE.IDLE)
			resetState()
		}
	}
	const onClickShapeButton = () => {
		if (currentState == EDITING_STATE.IDLE) {
			setCurrentState(EDITING_STATE.DRAWING_SHAPE)
		} else {
			// setCurrentState(EDITING_STATE.IDLE)
			resetState()
		}
	}
	const resetState = () => {
		setCurrentState(EDITING_STATE.IDLE)
		setCurrentDrawingState(EDITING_STATE.IDLE)
	}
	// const onClickShapeButton = () => {
	// 	setCurrentState(EDITING_STATE.DRAWING_SHAPE)
	// }

	const onVideoPlay = () => {
		setVideoState('playing')
		console.log('video time =', getVideoCurrentTime())
		// setTimeout(() => {
		// 	stopVideo()
		// }, 2000)
	}
	const onVideoPause = () => {
		setVideoState('paused')
		setVideoTime(getVideoCurrentTime())
		console.log('video time =', getVideoCurrentTime())
	}
	const videoOverlayClickHandler = (x: number, y: number) => {
		console.log('videoOverlayClickHandler called')
		if (currentDrawingState == EDITING_STATE.IDLE) {
			setDrawingPos({x: x, y: y})
			// setCurrentDrawingState(EDITING_STATE.DRAWING_LINE)
			setCurrentDrawingState(currentState)
		} 
		// else if (currentDrawingState == EDITING_STATE.DRAWING_LINE) {
		// 	// add Line Data
		// 	analysisStateData.createNewFeedback(AnalysisFeedbackTypes.LINE, getVideoCurrentTime())
		// 	analysisStateData.updateCurrentFeedbackData({
		// 		startPoint: {x:drawingPos.x, y:drawingPos.y},
		// 		// startPoint: {x:x, y:y},
		// 		// endPoint: {x:drawingPosEnd.x, y:drawingPosEnd.y}
		// 		endPoint: {x:x, y:y}
		// 	})
		// 	setCurrentState(EDITING_STATE.IDLE)
		// 	setCurrentDrawingState(EDITING_STATE.IDLE)
		// 	setTextNote('')
		// 	updateFeedbacks()
		// }
	}
	const createNewLineFeedback = (x: number, y: number) => {
		analysisStateData.createNewFeedback(AnalysisFeedbackTypes.LINE, getVideoCurrentTime())
		analysisStateData.updateCurrentFeedbackData({
			startPoint: {x:drawingPos.x, y:drawingPos.y},
			// startPoint: {x:x, y:y},
			// endPoint: {x:drawingPosEnd.x, y:drawingPosEnd.y}
			// startPoint: {x:drawingPosEnd.x, y:drawingPosEnd.y},
			endPoint: {x:x, y:y}
		})
		setCurrentState(EDITING_STATE.IDLE)
		setCurrentDrawingState(EDITING_STATE.IDLE)
		setTextNote('')
		updateFeedbacks()
	}
	const createNewShapeFeedback = () => { // x: number, y: number) => {
		analysisStateData.createNewFeedback(AnalysisFeedbackTypes.SHAPE_SQUARE, getVideoCurrentTime())
		analysisStateData.updateCurrentFeedbackData({
			x: drawingPos.x,
			y: drawingPos.y,
			width: drawingPosEnd.x - drawingPos.x,
			height: drawingPosEnd.y - drawingPos.y
		})
		setCurrentState(EDITING_STATE.IDLE)
		setCurrentDrawingState(EDITING_STATE.IDLE)
		setTextNote('')
		updateFeedbacks()
	}


	const stopVideo = () => {
		if (videoRef.current) {
			return videoRef.current.pause()
		}
	}

	// Returns the current time in video in seconds
	const getVideoCurrentTime = (): number => {
		if (videoRef.current) {
			return videoRef.current.currentTime
		}
		return 0
	}

	const addTextButtonClick = () => {
		if (textNote != '') {
			analysisStateData.createNewFeedback(AnalysisFeedbackTypes.TEXT_NOTE, getVideoCurrentTime())
			analysisStateData.updateCurrentFeedbackData({str: textNote})
			setTextNote('')
			updateFeedbacks()
		}
	}

	const recordButtonClick = () => {
		if (videoState === 'paused' && isRecording === false) {
			startRecording()
		}
		if (isRecording === true) {
			stopRecording()
		}
	}

	const startRecording = async () => {
		setIsRecording(true)
		analysisStateData.recordingStartDate = new Date()
		try {
			const audioStream:MediaStream = await navigator.mediaDevices.getUserMedia({
				audio: true
			})
			mediaStream.current = audioStream
			mediaRecorder.current = new MediaRecorder(audioStream)
			mediaRecorder.current.ondataavailable = (evt) => {
				if (evt.data.size > 0) {
					mediaChunks.current.push(evt.data)
				}
			}
			mediaRecorder.current.onstop = () => {
				const recordedBlob: Blob = new Blob(
					mediaChunks.current, {type: 'audio/webm'}
				)
				const url: string = URL.createObjectURL(recordedBlob)
				setMediaUrl(url)
				addRecordingData(url)
				mediaChunks.current = []
			}
			mediaRecorder.current.start()
		} catch (err) {
			setIsRecording(false)
			console.log('Error accessing microphone')
		}
	}
	const stopRecording = () => {
		setIsRecording(false)
		if (mediaRecorder.current && mediaRecorder.current.state === 'recording') {
			mediaRecorder.current.stop()
		}
		if (mediaStream.current) {
			mediaStream.current.getTracks().forEach((track: MediaStreamTrack) => {
				track.stop()
			})
		}
	}
	const addRecordingData = (url: string) => {
		analysisStateData.createNewFeedback(AnalysisFeedbackTypes.RECORDING, getVideoCurrentTime())
		analysisStateData.updateCurrentFeedbackData({src: url})
		if (analysisStateData.recordingStartDate) {
			const currentTime: number = Date.now()
			analysisStateData.updateCurrentFeedbackDuration(currentTime - analysisStateData.recordingStartDate?.getTime())
		}
		setTextNote('')
		updateFeedbacks()
	}

	const getDataText = (data: AnalysisFeedbackDataText): string => {
		return data.str
	}
	const getDataAudioSrc = (data: AnalysisFeedbackDataRecording): string => {
		return data.src
	}

	const getLineDataTop = (data: AnalysisFeedbackDataLine): number => {
		return data.startPoint.y
	}
	const getLineDataLeft = (data: AnalysisFeedbackDataLine): number => {
		return data.startPoint.x
	}
	const getLineDataAngle = (data: AnalysisFeedbackDataLine): number => {
		return GetAngleBetweenPoints(data.startPoint.x, data.startPoint.y, data.endPoint.x, data.endPoint.y)
	}
	const getLineLength = (data: AnalysisFeedbackDataLine): number => {
		return GetLengthBetweenPoints(
			videoWrapperWidth / 100 * data.startPoint.x,
			videoWrapperHeight / 100 * data.startPoint.y,
			videoWrapperWidth / 100 * data.endPoint.x,
			videoWrapperHeight / 100 * data.endPoint.y
		)
		// return GetLengthBetweenPoints(
		// 	data.startPoint.x,
		// 	data.startPoint.y,
		// 	data.endPoint.x,
		// 	data.endPoint.y
		// )
	}

	const getSquareData = (data: AnalysisFeedbackDataShapeRectangle): AnalysisFeedbackDataShapeRectangle => {
		return data
	}
	const getTextData = (data: AnalysisFeedbackDataText): AnalysisFeedbackDataText => {
		return data
	}


	// ========================================================= PREVIEW STUFF

	const [previewFeedbacks, setPreviewFeedbacks] = useState<AnalysisFeedback[]>([])
	const [previewStated, setPreviewStarted] = useState<boolean>(false)
	const previewButtonClicked = () => {
		// setShowPreviewVideo(true)
		dispatch(setShowPreview(true))
	}
	useEffect(() => {
		console.log('Preview Video loaded')
		// if (showPreviewVideo && previewVideoRef.current) {
		if (showPreview && previewVideoRef.current) {
			console.log('showPreviewVideo && Preview current exists')
			if (previewStated == false) {
				setPreviewStarted(true)
				startPreviewPlayback()
			}
		} else {
			console.log('Preview current not existing')
		}
	}, [showPreview])
	// }, [previewVideoRef.current, showPreview])
	
	const startPreviewPlayback = () => {
		if (showPreview && previewVideoRef.current) {
			previewVideoRef.current.play()
		}
	}
	const previewPlaybackStarted = () => {
		// if (showPreview && previewVideoRef.current) {
		if (showPreview && previewVideoRef.current) {
			let stopTime: number = 0
			feedbacks.forEach((feedback: AnalysisFeedback, index: number) => {
				if (index == 0) {
					stopTime = (feedback.time * 1000)
				}
				setTimeout(() => {
					setPreviewFeedbacks([feedback])
					previewVideoRef.current?.pause()
					setTimeout(() => {
						setPreviewFeedbacks([])
						previewVideoRef.current?.play()						
					}, feedback.duration)
					stopTime += feedback.duration
				// }, stopTime)
				}, (feedback.time * 1000))
			})
		}
	}
	// }, [previewVideoRef.current, showPreviewVideo])
	// const previewVideoLoaded = () => {
	// 	console.log('Preview Video loaded')
	// 	if (previewVideoRef.current) {
	// 		console.log('Preview current exists')
	// 	} else {
	// 		console.log('Preview current not existing')
	// 	}
	// }

	return (
		<div className='dashboard-tool-content-area-wrap'>
			<div className='dashboard-tool-column-wrap'>
				<div className='dashboard-tool-button-wrap'>
					{/* <button 
						className='dashboard-tool-button'
						disabled={videoState === 'playing' || isRecording}
						style={useMemo(
							() => ({
								background: currentState == EDITING_STATE.DRAWING ? '#444' : 'initial'
							}),
							[currentState]
						)}
						onClick={() => {
							onClickEditButton()
						}}
					>
						<img
							className='dashboard-tool-button-img'
							src='/imgs/icons/tool/icon-tool-edit.svg'
							alt='Edit button'
						/>
					</button> */}
					<button 
						className='dashboard-tool-button'
						disabled={videoState === 'playing' || isRecording}
						style={useMemo(
							() => ({
								background: currentState == EDITING_STATE.DRAWING_LINE ? '#444' : 'initial'
							}),
							[currentState]
						)}
						onClick={() => {
							onClickLineButton()
						}}
					>
						<img
							className='dashboard-tool-button-img'
							src='/imgs/icons/tool/icon-tool-line.svg'
							alt='Line button'
						/>
					</button>
					<button 
						className='dashboard-tool-button'
						disabled={videoState === 'playing' || isRecording}
						style={useMemo(
							() => ({
								background: currentState == EDITING_STATE.DRAWING_ANGLE ? '#444' : 'initial'
							}),
							[currentState]
						)}
						onClick={() => {
							onClickLineButton()
						}}
					>
						<img
							className='dashboard-tool-button-img'
							src='/imgs/icons/tool/icon-tool-angle.svg'
							alt='Line button'
						/>
					</button>
					<button 
						className='dashboard-tool-button'
						disabled={videoState === 'playing' || isRecording}
						style={useMemo(
							() => ({
								background: currentState == EDITING_STATE.DRAWING_SHAPE ? '#444' : 'initial'
							}),
							[currentState]
						)}
						onClick={() => {
							onClickShapeButton()
						}}
					>
						<img
							className='dashboard-tool-button-img'
							src='/imgs/icons/tool/icon-tool-shape.svg'
							alt='Shape button'
						/>
					</button>
				</div>
				<div className='dashboard-tool-video-area-wrap'>
					<div 
						className='dashboard-tool-video-wrap'
						ref={videoWrapperRef}
						// style={useMemo(() => ({
						// 		height: videoWrapperWidth / VIDEO_SPACE_HEIGHT_RATIO
						// 	}),
						// 	[videoWrapperWidth])
						// }
					>
						{videoSrc &&
							<video
								id="example_video_1"
								ref={videoRef}
								className="video-js vjs-default-skin dashboard-tool-video"
								// width="600"
								// height="264"
								// src={`${VIDEO_FILE_PATH}${userStateData.videoFileName}`}
								src={videoSrc}
								typeof='video/mp4'
								onPlay={() => {
									onVideoPlay()
								}}
								onPause={() => {
									onVideoPause()
								}}
								// onRateChange={() => {
								// 	console.log('time change')
								// }}
								controls={!isRecording && currentState == EDITING_STATE.IDLE}
							/>
						}
						{videoState == 'paused' && feedbacks.map((feedback: AnalysisFeedback, index: number) => 
							<>
								{feedback.time == videoTime && feedback.type == AnalysisFeedbackTypes.LINE &&
									<div
										key={`feedback_line${index}`}
										style={{
											position: 'absolute',
											width: 2,
											height: drawingLineHeight,
											// height: getLineLength(feedback.data as AnalysisFeedbackDataLine),
											top: `${getLineDataTop(feedback.data as AnalysisFeedbackDataLine)}%`,
											left: `${getLineDataLeft(feedback.data as AnalysisFeedbackDataLine)}%`,
											background: '#000000',
											border: '1px solid #FFFFFF',
											transformOrigin: 'top left',
											// transformOrigin: 'bottom center',
											transform: `rotate(${getLineDataAngle(feedback.data as AnalysisFeedbackDataLine)}deg)`
										}}
									/>
								}
								{feedback.time == videoTime && feedback.type == AnalysisFeedbackTypes.SHAPE_SQUARE &&
									<div
										key={`feedback_square${index}`}
										style={{
											position: 'absolute',
											top: `${getSquareData(feedback.data as AnalysisFeedbackDataShapeRectangle).y}%`,
											left: `${getSquareData(feedback.data as AnalysisFeedbackDataShapeRectangle).x}%`,
											width: `${getSquareData(feedback.data as AnalysisFeedbackDataShapeRectangle).width}%`,
											height: `${getSquareData(feedback.data as AnalysisFeedbackDataShapeRectangle).height}%`,
											background: 'rgba(0,255,0,0.25)',
											border: '1px solid #00FF00'
										}}
									/>
								}
								{feedback.time == videoTime && feedback.type == AnalysisFeedbackTypes.TEXT_NOTE &&
									<div
										key={`feedback_text${index}`}
										style={{
											position: 'absolute',
											display: 'flex',
											bottom: 20,
											left: 20,
											width: `calc(100% - 60px)`,
											// height: `${getSquareData(feedback.data as AnalysisFeedbackDataShapeRectangle).height}%`,
											background: 'rgba(0,0,0,0.45)',
											border: '1px solid #000000',
											padding: 10,
											borderRadius: 5,
											color: '#ffffff'
										}}
									>{getTextData(feedback.data as AnalysisFeedbackDataText).str}</div>
								}
							</>
						)}
						{currentDrawingState == EDITING_STATE.DRAWING_LINE &&
							<div
								style={{
									position: 'absolute',
									width: 2,
									height: drawingLineHeight,
									// top: `${drawingPos.y < drawingPosEnd.y ? drawingPos.y : drawingPosEnd.y}%`,
									// left: `${drawingPos.x < drawingPosEnd.x ? drawingPos.x : drawingPosEnd.x}%`,
									top: `${drawingPos.y}%`,
									left: `${drawingPos.x}%`,
									background: '#000000',
									border: '1px solid #FFFFFF',
									transformOrigin: 'top left',
									transform: `rotate(${drawingLineAngle}deg)`
								}}
							/>
						}
						{currentDrawingState == EDITING_STATE.DRAWING_SHAPE &&
							<div
								style={{
									position: 'absolute',
									top: `${drawingPos.y}%`,
									left: `${drawingPos.x}%`,
									width: `${drawingPosEnd.x - drawingPos.x}%`,
									height: `${drawingPosEnd.y - drawingPos.y}%`,
									background: 'rgba(0,255,0,0.25)',
									border: '1px solid #00FF00'
								}}
							/>
						}
						{currentState != EDITING_STATE.IDLE &&
							<div
								className='dashboard-tool-video-overlay'
								onClick={(evt) => {
									const bounds:DOMRect = evt.currentTarget.getBoundingClientRect()
									// console.log(100 / bounds.width * (evt.clientX - bounds.left))
									videoOverlayClickHandler(
										100 / bounds.width * (evt.clientX - bounds.left),
										100 / bounds.height * (evt.clientY - bounds.top)
									)
									if (currentDrawingState == EDITING_STATE.DRAWING_LINE) {
										createNewLineFeedback(
											100 / bounds.width * (evt.clientX - bounds.left),
											100 / bounds.height * (evt.clientY - bounds.top)
											// evt.clientX, evt.clientY
										)
									} else if (currentDrawingState == EDITING_STATE.DRAWING_SHAPE) {
										createNewShapeFeedback()
									}
									setDrawingClientPos({
										x: evt.clientX,
										y: evt.clientY
									})
								}}
								onMouseMove={(evt) => {
									const bounds:DOMRect = evt.currentTarget.getBoundingClientRect()
									setDrawingPosEnd({
										x: 100 / bounds.width * (evt.clientX - bounds.left),
										y: 100 / bounds.height * (evt.clientY - bounds.top)
									})
									// setDrawingPosEnd({
									// 	x: evt.clientX,
									// 	y: evt.clientY
									// })

									// const a: number = evt.clientX > drawingClientPos.x ? drawingClientPos.x - evt.clientX : evt.clientX - drawingClientPos.x
									// const b: number = evt.clientY > drawingClientPos.y ? drawingClientPos.y - evt.clientY : evt.clientY - drawingClientPos.y
									// setDrawingLineHeight(Math.sqrt((a*a)+(b*b)))
									setDrawingLineHeight(GetLengthBetweenPoints(drawingClientPos.x, drawingClientPos.y, evt.clientX, evt.clientY))
									
									// const dx: number = drawingClientPos.x - evt.clientX
									// const dy: number = drawingClientPos.y - evt.clientY
									// // dx = ex - cx
									// const theta: number = Math.atan2(dy,dx) // Math.atan(dy/dx) // Math.arctan(dy/dx)
									// // theta *= 180/pi // rads to degs
									// setDrawingLineAngle((theta * (180 / 3.141) + 90))
									// // setDrawingLineAngle(theta * (180 / 3.141))
									setDrawingLineAngle(GetAngleBetweenPoints(drawingClientPos.x, drawingClientPos.y, evt.clientX, evt.clientY))
								}}
							/>
						}
					</div>
					<div
						className='dashboard-tool-feedback-wrap'
					>
						{feedbacks.map((feedback: AnalysisFeedback, index: number) => 
							<div
								className='dashboard-tool-feedback-item'
								key={`feedback_${index}`}
							>
								<button 
									className='dashboard-tool-feedback-item-symbol'
									disabled={videoState === 'playing' || isRecording}
									onClick={() => {
										if (videoRef.current) {
											videoRef.current.currentTime = feedback.time
											setVideoTime(feedback.time)
										}
									}}
								>
									{feedback.type == AnalysisFeedbackTypes.RECORDING &&
										<img
											className='dashboard-tool-feedback-item-img'
											src='/imgs/icons/tool/icon-tool-record.svg'
											alt='play symbol'
										/>
									}
									{feedback.type == AnalysisFeedbackTypes.TEXT_NOTE &&
										<div
											className='dashboard-tool-feedback-item-text'
										>T</div>
									}
									{feedback.type == AnalysisFeedbackTypes.LINE &&
										<img
											className='dashboard-tool-feedback-item-img'
											src='/imgs/icons/tool/icon-tool-line.svg'
											alt='line button'
										/>
									}
									{feedback.type == AnalysisFeedbackTypes.SHAPE_SQUARE &&
										<img
											className='dashboard-tool-feedback-item-img'
											src='/imgs/icons/tool/icon-tool-shape.svg'
											alt='shape button'
										/>
									}
								</button>
								<div className='dashboard-tool-feedback-item-details'>
									<div
										className='dashboard-tool-feedback-item-details-str'
									>
										{/* {Math.floor(feedback.time / 60)}:{Math.floor(feedback.time % 60) < 10 ? `0${Math.floor(feedback.time % 60)}` : Math.floor(feedback.time % 60)}  */}
										{/* {` - ${feedback.duration} sec - `} */}
										{`${feedback.time.toFixed(2)} sec - ${feedback.duration / 1000} sec - `}
										{feedback.type == AnalysisFeedbackTypes.TEXT_NOTE && feedback.data && `${getDataText(feedback.data as AnalysisFeedbackDataText)}`}
										{feedback.type == AnalysisFeedbackTypes.LINE && 'LINE'}
									</div>
									{feedback.type == AnalysisFeedbackTypes.RECORDING && 
										<>
											<audio
												className='dashboard-tool-feedback-item-details-audio'
												controls 
												src={getDataAudioSrc(feedback.data as AnalysisFeedbackDataRecording)}
												id={`snd${getDataAudioSrc(feedback.data as AnalysisFeedbackDataRecording)}`}
											/>
										</>
									}
								</div>
								<button 
									className='dashboard-tool-feedback-item-button'
									disabled={videoState === 'playing' || isRecording}
								>
									<img
										className='dashboard-tool-feedback-item-delete-img'
										src='/imgs/icons/icon-delete-x.svg'
										alt='delete button'
									/>
								</button>
							</div>
						)}
					</div>
				</div>
			</div>
			<div
				className='dashboard-tool-record-wrap'
			>
				<div className='dashboard-tool-record-title'>Voiceover</div>
				<div
					className='dashboard-tool-record-button-wrap'
					onClick={() => {
						recordButtonClick()
					}}
				>
					<img
						className='dashboard-tool-record-button-img'
						// src='/imgs/icons/tool/icon-tool-record.svg'
						src={isRecording ? '/imgs/icons/tool/icon-tool-stop.svg' : '/imgs/icons/tool/icon-tool-record.svg'}
						alt='Record button'
					/>
					<div className='dashboard-tool-record-button-label'>{isRecording ? 'Stop' : 'Record'}</div>
				</div>
				<div className='dashboard-tool-record-title'>Text Comment</div>
				<textarea 
					className='dashboard-tool-record-text-area'
					value={textNote}
					disabled={videoState === 'playing'}
					onChange={(evt) => {
						setTextNote(evt.target.value)
					}}
				/>
				<div
					className='dashboard-tool-record-button-wrap'
					onClick={() => {
						addTextButtonClick()
					}}
				>
					{/* <img
						className='dashboard-tool-record-button-img'
						// src='/imgs/icons/tool/icon-tool-record.svg'
						src={isRecording ? '/imgs/icons/tool/icon-tool-stop.svg' : '/imgs/icons/tool/icon-tool-record.svg'}
						alt='Add button'
					/> */}
					<div className='dashboard-tool-add-button-label'>+ Add Note</div>
				</div>
				<div
					className='dashboard-tool-record-button-wrap'
					onClick={() => {
						previewButtonClicked()
					}}
				>
					<div className='dashboard-tool-add-button-label'>Preview Video</div>
				</div>
			</div>
			{showPreview && // showPreviewVideo && 
				<div
					className='preview-video-wrapper'
				>
					<div
						className='dashboard-tool-video-wrap preview-dashboard-tool-video-wrap'
					>
						{videoSrc &&
							<video
								ref={previewVideoRef}
								className="video-js vjs-default-skin dashboard-tool-video"
								src={videoSrc}
								typeof='video/mp4'
								onPlay={() => {
									previewPlaybackStarted()
								}}
							/>
						}
						{previewFeedbacks.map((feedback: AnalysisFeedback, index: number) => 
							<>
								{feedback.type == AnalysisFeedbackTypes.LINE &&
									<div
										key={`feedback_preview_line${index}`}
										style={{
											position: 'absolute',
											width: 2,
											height: getLineLength(feedback.data as AnalysisFeedbackDataLine),
											top: `${getLineDataTop(feedback.data as AnalysisFeedbackDataLine)}%`,
											left: `${getLineDataLeft(feedback.data as AnalysisFeedbackDataLine)}%`,
											background: '#000000',
											border: '1px solid #FFFFFF',
											transformOrigin: 'top left',
											transform: `rotate(${getLineDataAngle(feedback.data as AnalysisFeedbackDataLine)}deg)`
										}}
									/>
								}
								{feedback.type == AnalysisFeedbackTypes.SHAPE_SQUARE &&
									<div
										key={`feedback_preview_square${index}`}
										style={{
											position: 'absolute',
											top: `${getSquareData(feedback.data as AnalysisFeedbackDataShapeRectangle).y}%`,
											left: `${getSquareData(feedback.data as AnalysisFeedbackDataShapeRectangle).x}%`,
											width: `${getSquareData(feedback.data as AnalysisFeedbackDataShapeRectangle).width}%`,
											height: `${getSquareData(feedback.data as AnalysisFeedbackDataShapeRectangle).height}%`,
											background: 'rgba(0,255,0,0.25)',
											border: '1px solid #00FF00'
										}}
									/>
								}
								{feedback.type == AnalysisFeedbackTypes.TEXT_NOTE &&
									<div
										key={`feedback_preview_text${index}`}
										style={{
											position: 'absolute',
											display: 'flex',
											bottom: 20,
											left: 20,
											width: `calc(100% - 60px)`,
											background: 'rgba(0,0,0,0.45)',
											border: '1px solid #000000',
											padding: 10,
											borderRadius: 5,
											color: '#ffffff'
										}}
									>{getTextData(feedback.data as AnalysisFeedbackDataText).str}</div>
								}
							</>
						)}
					</div>
				</div>
			}
		</div>
	)
}

export default DashboardToolEditArea
